// extracted by mini-css-extract-plugin
module.exports = {"login-button-label":"LoginButton_login-button-label__D_F2i"};